/**
 * City select options for the Locations collection.
 * Values match CityId in src/lib/mock/mapLocations.ts (route / mock IDs).
 */
export const cityIds = ['berlin', 'cologne', 'frankfurt', 'tuebingen'] as const

export type LocationCityId = (typeof cityIds)[number]

export function isLocationCityId(value: string): value is LocationCityId {
  return (cityIds as readonly string[]).includes(value)
}

export const citySelectOptions = [
  { label: 'Berlin', value: 'berlin' },
  { label: 'Cologne', value: 'cologne' },
  { label: 'Frankfurt', value: 'frankfurt' },
  { label: 'Tübingen', value: 'tuebingen' },
] as const
